import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import type { VisuallyHiddenPropsInterface } from './types/visually-hidden.types';

export const VisuallyHidden = forwardRef<HTMLSpanElement, VisuallyHiddenPropsInterface>(
  (props: VisuallyHiddenPropsInterface, forwardedRef) => {
    const { asChild = false, children, className, css: cssProp, ...rest } = props;

    const styles = css({ srOnly: true }, cssProp);

    const Component = asChild ? Slot : 'span';

    return (
      <Component
        className={cx('c11n', 'c11n_visually-hidden', styles, className)}
        data-c11n-component="VisuallyHidden"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...rest}
      >
        {children}
      </Component>
    );
  },
);

VisuallyHidden.displayName = 'VisuallyHidden';
